import { Helper} from './Helper';
import { MenuNode } from './MenuNode';
import { Scheduler }  from './Scheduler';
export class Programs{




	static BasicP0096_Start : number;
	static BasicP0096_Runs = 0;
	static BasicP0096_State = 'stopped';
	static BasicP0096(t:any){
		Programs.BasicP0096_Runs++;
		console.log("Program running: "+Programs.BasicP0096_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.getIconBar().saveState('p0096.state');
		t.getIconBar().blinkIcon('heating');
		let value : number =5;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = 'P.096';
			
		});
		for(let i=0;i<40;i++){
			scheduler.at(6+i,()=>{
				t.smallLetters = 'on';
			});
		}
		scheduler.at(47,()=>{
			t.smallLetters = '--:--';
		});
		scheduler.at(52,()=>{
			scheduler.cancel();
			t.menuService.goto('basic_pruefprogramme');
		});
		scheduler.at(58,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(60,()=>{
			t.menuService.goto('basic_pruefprogramme');
			scheduler.cancel();
			t.getIconBar().restoreState('p0096.state');
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 43){
				return;
			}
			if(evt=='back'){
				scheduler.gotoTick(58);
			}
		};
	}



	static BasicP0036_Start : number;
	static BasicP0036_Runs = 0;
	static BasicP0036_State = 'stopped';
	static BasicP0036(t:any){
		Programs.BasicP0036_Runs++;
		console.log("Program running: "+Programs.BasicP0036_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.getIconBar().saveState('p0036.state');
		t.getIconBar().blinkIcon('heating');
		let value : number =5;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = 'P.036'
			
		});
		scheduler.at(3,()=>{
			t.menuService.undisableButton('back');
		});

		for(let i=0;i<41;i++){
			scheduler.at(3+i,()=>{
				t.smallLetters = '00:'+Helper.twoDigits(43-i);
			});
		}
		scheduler.at(43,()=>{
			t.smallLetters = '--:--';
		});
		scheduler.at(48,()=>{
			scheduler.cancel();
			t.menuService.goto('basic_pruefprogramme');
		});
		scheduler.at(50,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(53,()=>{
			scheduler.cancel();
			t.getIconBar().restoreState('p0036.state');
			t.menuService.goto('basic_pruefprogramme');
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 43){
				return;
			}
			if(evt=='back'){
				scheduler.gotoTick(50);
			}
		};
	}




	static BasicP0035_Start : number;
	static BasicP0035_Runs = 0;
	static BasicP0035_State = 'stopped';
	static BasicP0035(t:any){
		Programs.BasicP0035_Runs++;
		console.log("Program running: "+Programs.BasicP0035_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.getIconBar().saveState('p0035.state');
		t.getIconBar().blinkIcon('heating');
		let value : number =5;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = 'P.035'
			
		});
		for(let i=0;i<41;i++){
			scheduler.at(3+i,()=>{
				t.smallLetters = '00:'+Helper.twoDigits(43-i);
			});
		}
		scheduler.at(43,()=>{
			t.smallLetters = '--:--';
		});
		scheduler.at(48,()=>{
			scheduler.cancel();
			t.menuService.goto('basic_pruefprogramme');
		});
		scheduler.at(50,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(53,()=>{
			t.menuService.goto('basic_pruefprogramme');
			scheduler.cancel();
			t.getIconBar().restoreState('p0035.state');
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 43){
				return;
			}
			if(evt=='back'){
				scheduler.gotoTick(50);
			}
		};
	}

	static BasicP0008_Start : number;
	static BasicP0008_Runs = 0;
	static BasicP0008_State = 'stopped';
	static BasicP0008(t:any){
		Programs.BasicP0008_Runs++;
		console.log("Program running: "+Programs.BasicP0008_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.menuService.disableButton('back');
		t.getIconBar().saveState('beforeP0008');
		//t.getIconBar().blinkIcon('heating');
		let value : number =16;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '1.7'
			t._unit = 'STD_UNIT_BAR_NORMAL_LEFT';
		});
		scheduler.at(5,()=>{
			t.menuService.undisableButton('back');
		});
		for(let i=0;i<=15*60;i++){
			scheduler.at(5+i,()=>{
				t.smallLetters = Helper.twoDigits(Math.floor((15*60-i)/60))+':'+Helper.twoDigits((15*60-i)%60);
				t.bigLetters = '1.7'
				t._unit = 'STD_UNIT_BAR_NORMAL_LEFT';
			});
		}
		scheduler.at(15*60+10,()=>{
			t.smallLetters = '--:--';
		});
		scheduler.at(15*60+13,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._unit = '';
			t._showScale = true;
			t._scaleType = 'loadinganimation';
		});
		scheduler.at(15*60+16,()=>{
			scheduler.cancel();
			t.getIconBar().restoreState('beforeP0008');
			t.menuService.goto('basic_pruefprogramme');
		});
		
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 50*60+10){
				return;
			}
			if(evt=='back'){
				t._useOverride = false;
				scheduler.gotoTick(15*60+9);
			}
			if(evt == 'up'|| evt == 'down'){
				let value = 16;
				if(t.value){
					value = t.value;
				}
				if(evt == 'up'){
					value++;
					if(value > 20){
						value = 5;
					}
				}
				if(evt == 'down'){
					value--;
					if(value < 5){
						value = 20;
					}
				}
				t.value = value;
				t._overrideBigLetters = t.value+"";

				t._overrideUnit = 'AICI_UNIT_KW';
				t._useOverride = true;
				if(t.undoOverride){
					clearTimeout(t.undoOverride);
					t.undoOverride = undefined;
				}
				t.undoOverride = setTimeout( ()=>{
					t._useOverride = false;
				},2000);
			}
		};
		


	}
		
	static BasicP0003_Start : number;
	static BasicP0003_Runs = 0;
	static BasicP0003_State = 'stopped';
	static BasicP0003(t:any){
		Programs.BasicP0003_Runs++;
		console.log("Program running: "+Programs.BasicP0003_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.getIconBar().saveState('p0003.state');
		let value : number =5;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '25.0'
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(8,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = '';
			t.bigLetters = 'S.093'
			t._unit = undefined;
		});
		scheduler.at(19,()=>{
			t.smallLetters = '15:00';
			t.bigLetters = '25.0'

			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		for(let i=0;i<15*60;i++){
			scheduler.at(20+i,()=>{
				t.smallLetters = Helper.twoDigits( Math.floor((15*60-i-1)/60) )+':'+Helper.twoDigits( (15*60-i-1)%60 );
				
				let b = parseFloat(t.bigLetters);
				if(b<80 && (i%1)==0 ){
					b+=0.5;
				}
				t.bigLetters = b.toFixed(1);
			

				t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
			});
		}

		scheduler.at(15*60+23,()=>{
			t.smallLetters = '--:--';
			t.bigLetters = '80.0';
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(15*60+27,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(15*60+30,()=>{
			t.menuService.goto('basic_pruefprogramme');
			scheduler.cancel();
			t.getIconBar().restoreState('p0003.state');
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 15*60+23){
				return;
			}
			if(evt=='back'){
				scheduler.gotoTick(15*60+27);
			}
		};
	}




	static BasicP0001_Start : number;
	static BasicP0001_Runs = 0;
	static BasicP0001_State = 'stopped';
	static BasicP0001(t:any){
		Programs.BasicP0001_Runs++;
		console.log("Program running: "+Programs.BasicP0001_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.getIconBar().saveState('beforeP0001');
		t.getIconBar().blinkIcon('heating');
		let value : number =5;
		scheduler.at(3,()=>{
			t.menuService.undisableButton('slider');
			t.menuService.undisableButton('up');
			t.menuService.undisableButton('down');
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = value+"";
			t._unit = 'AICI_UNIT_KW';
		});
		scheduler.at(8,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = '';
			t.bigLetters = 'S.093'
			t._unit = undefined;
		});
		scheduler.at(19,()=>{
			t.menuService.undisableButton('up');
			t.menuService.undisableButton('down');
			t.menuService.undisableButton('slider');
			t.smallLetters = '00:20';
			t.bigLetters = value+"";
			t._unit = 'AICI_UNIT_KW';
		});
		for(let i=0;i<15*60;i++){
			scheduler.at(20+i,()=>{
				t.smallLetters = Helper.twoDigits(Math.floor((15*60-i)/60))+':'+Helper.twoDigits((15*60-i)%60);
				t.bigLetters = value+"";
				t._unit = 'AICI_UNIT_KW';
			});
		}
		scheduler.at(15*60+23,()=>{
			t.smallLetters = '--:--';
			t.bigLetters = value+"";
			t._unit = 'AICI_UNIT_KW';
		});
		scheduler.at(15*60+27,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._unit = '';
			t._showScale = true;
			t._scaleType = 'loadinganimation';
		});
		
		scheduler.at(15*60+30,()=>{
			t.menuService.goto('basic_pruefprogramme');
			scheduler.cancel();
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 15*60+27){
				return;
			}
			if(evt=='back'){
				t._useOverride = false;
				scheduler.gotoTick(15*60+23);
			}
			if(evt == 'up'|| evt == 'down'){
				let value = 5;
				if(t.value){
					value = t.value;
				}
				if(evt == 'up'){
					value++;
					if(value > 20){
						value = 5;
					}
				}
				if(evt == 'down'){
					value--;
					if(value < 5){
						value = 20;
					}
				}
				t.value = value;
				t._overrideBigLetters = t.value+"";

				t._overrideUnit = 'AICI_UNIT_KW';
				t._useOverride = true;
				if(t.undoOverride){
					clearTimeout(t.undoOverride);
					t.undoOverride = undefined;
				}
				t.undoOverride = setTimeout( ()=>{
					t._useOverride = false;
					t.getIconBar().restoreState('beforeP0001');
				},2000);
			}
		};
		


	}



	static BasicP0000_Start : number;
	static BasicP0000_Runs = 0;
	static BasicP0000_State = 'stopped';
	static BasicP0000(t:any){
		Programs.BasicP0000_Runs++;
		console.log("Program running: "+Programs.BasicP0000_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');
		t.menuService.disableButton('back');
		t.getIconBar().saveState('beforeP0000');
		t.getIconBar().disableIcon('heating');
		let value : number =16;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '1.2'
			t._unit = 'STD_UNIT_BAR_NORMAL_LEFT';
		});
		scheduler.at(5,()=>{
			t.menuService.undisableButton('back');
		});
		for(let i=0;i<=(5*60);i++){
			console.log("adding tick "+(5+i));
			scheduler.at(5+i,()=>{
				console.log("timertick "+(5+i));
				t.smallLetters = Helper.twoDigits(Math.floor((5*60-i)/60))+':'+Helper.twoDigits((5*60-i)%60);
				t.bigLetters = '1.2'
				t._unit = 'STD_UNIT_BAR_NORMAL_LEFT';
			});
		}
		scheduler.at(5*60+9,()=>{
			t.smallLetters = '--:--';
			console.log("smallletterstick "+(5*60+9));
		});
		scheduler.at(5*60+12,()=>{
			console.log("aborting tick "+(5*60+12));
			scheduler.cancel();
			t.menuService.goto('basic_pruefprogramme');
		});
		
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 5*60+12){
				return;
			}
			if(evt=='back'){
				t._useOverride = false;
				scheduler.gotoTick(5*60+9);
				return;
			}
			if(evt == 'up'|| evt == 'down'){
				let value = 16;
				if(t.value){
					value = t.value;
				}
				if(evt == 'up'){
					value++;
					if(value > 20){
						value = 5;
					}
				}
				if(evt == 'down'){
					value--;
					if(value < 5){
						value = 20;
					}
				}
				t.value = value;
				t._overrideBigLetters = t.value+"";

				t._overrideUnit = 'AICI_UNIT_KW';
				t._useOverride = true;
				if(t.undoOverride){
					clearTimeout(t.undoOverride);
					t.undoOverride = undefined;
				}
				t.undoOverride = setTimeout( ()=>{
					t._useOverride = false;
					t.getIconBar().saveState('beforeP0001');
				},2000);
			}
		};
		


	}

	static chimneySweepStart : number;
	static chimneySweepDynamicRuns = 0;
	static chimneySweepState = 'stopped';
	static chimneySweepDynamic(t:any){
		Programs.chimneySweepDynamicRuns++;
		console.log("Program running: "+Programs.chimneySweepDynamicRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if(Programs.chimneySweepState == 'stopped'){
			Programs.chimneySweepState = 'running';
			let date = new Date();
			Programs.chimneySweepStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.value = t.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			t.unit = t.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();
			t.showIconBar = true;
			if(idx == 1){
				
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.chimneySweepStart;
				t.dashIcon='iconChimneySweep';
				t.title = t.translator.tr('DELIGHT_MAIN_MENU_ENTRY_CHIMNEY_SWEEPER');
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.chimneySweepState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.chimneySweepStart;
				Programs.chimneySweepStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.chimneySweepState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}

	static chimneySweepMaxDHWStart : number;
	static chimneySweepMaxDHWRuns = 0;
	static chimneySweepMaxDHWState = 'stopped';
	static chimneySweeepMaxDHW(t:any){
		Programs.chimneySweepMaxDHWRuns++;
		console.log("Program running: "+Programs.chimneySweepMaxDHWRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if(Programs.chimneySweepMaxDHWState == 'stopped'){
			Programs.chimneySweepMaxDHWState = 'running';
			let date = new Date();
			Programs.chimneySweepMaxDHWStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		
		t.getText = function(idx:number){
			t.showIconBar = true;
			t.value = t.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			t.unit = t.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();

			t.title = t.translator.tr('DELIGHT_CHIMNEY_MENU_TITLE');
			if(idx == 1){
				
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.chimneySweepMaxDHWStart;
				t.dashIcon='iconChimneySweep';
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.chimneySweepMaxDHWState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.chimneySweepMaxDHWStart;
				Programs.chimneySweepMaxDHWStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.chimneySweepState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}



	static PurgeProgrammeStart : number;
	static PurgeProgrammeRuns = 0;
	static PurgeProgrammeState = 'stopped';
	static PurgeProgramme(t:any){
		Programs.PurgeProgrammeRuns++;
		console.log("Program running: "+Programs.PurgeProgrammeRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.PurgeProgrammeState == 'stopped'){
			Programs.PurgeProgrammeState = 'running';
			let date = new Date();
			Programs.PurgeProgrammeStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'P.00 '+t.translator.tr('DELIGHT_TEST_PROGRAM_AIRVENT');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			if(idx == 0){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_AIRVENT_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){
				
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.PurgeProgrammeStart;
				t.unit = "bar";
				t.value = "1.2";
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.PurgeProgrammeState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.PurgeProgrammeStart;
				Programs.PurgeProgrammeStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.PurgeProgrammeState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}


	static FillWaterProgramStart : number;
	static FillWaterProgramRuns = 0;
	static FillWaterProgramState = 'stopped';
	static FillWaterProgram(t:any){
		Programs.FillWaterProgramRuns++;
		console.log("Program running: "+Programs.FillWaterProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.FillWaterProgramState == 'stopped'){
			Programs.FillWaterProgramState = 'running';
			let date = new Date();
			Programs.FillWaterProgramStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'P.08 '+t.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt(""+d.getTime())-Programs.FillWaterProgramStart;
			if(idx == 0){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER_DESCRIPTION');
			}
			if(idx == 2){
				if(diff >= duration){
					return '';
				}else{
					return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}
			if(idx == 1){
				
				t.unit = "bar";
				t.value = "1.2";
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.FillWaterProgramState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.FillWaterProgramStart;
				Programs.FillWaterProgramStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.FillWaterProgramState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}




	static automaticWaterFillStart : number;
	static automaticWaterFillRuns = 0;
	static automaticWaterFillState = 'stopped';
	static automaticWaterFill(t:any){
		Programs.automaticWaterFillRuns++;
		console.log("Program running: "+Programs.automaticWaterFillRuns);
		let getTitle = t.getSubtitle;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		if(Programs.automaticWaterFillState == 'stopped'){
			Programs.automaticWaterFillState = 'running';
			let date = new Date();
			Programs.automaticWaterFillStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getSubtitle = function(){
			
			t.dashIcon = '';
			
			let d = new Date();
			let diff = parseInt(""+d.getTime())-Programs.automaticWaterFillStart;
			
			if(diff < duration ){
				return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
			}

			if(diff >= duration && (diff-1000) <= (duration)){
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";
			}
			if(diff > duration){
				Programs.automaticWaterFillState = 'stopped';
				t.menuService.goto(t.node.getTargetNode());
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.automaticWaterFillStart;
				Programs.automaticWaterFillStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.automaticWaterFillState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);

			}else{
				eH.call(t,evt);
			}
		}
	}
	

	static AdjustableLoadProgramStart : number;
	static AdjustableLoadProgramRuns = 0;
	static AdjustableLoadProgramState = 'stopped';
	static AdjustableLoadProgram(t:any){
		Programs.AdjustableLoadProgramRuns++;
		console.log("Program running: "+Programs.AdjustableLoadProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.AdjustableLoadProgramState == 'stopped'){
			Programs.AdjustableLoadProgramState = 'running';
			let date = new Date();
			Programs.AdjustableLoadProgramStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'P.01 '+t.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let scale = t.ioService.getDeviceInfo().getScale('adjustablePowerLoad')
			t.value = scale.getCurrentValue();
			t.unit = scale.getUnit();
			if(idx == 0){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){
				
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.AdjustableLoadProgramStart;

				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.AdjustableLoadProgramState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.AdjustableLoadProgramStart;
				Programs.AdjustableLoadProgramStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.AdjustableLoadProgramState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}


	static MaxEingestBelastungProgrammStart : number;
	static MaxEingestBelastungProgrammRuns = 0;
	static MaxEingestBelastungProgrammState = 'stopped';
	static MaxEingestBelastungProgramm(t:any){
		Programs.MaxEingestBelastungProgrammRuns++;
		console.log("Program running: "+Programs.MaxEingestBelastungProgrammRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.MaxEingestBelastungProgrammState == 'stopped'){
			Programs.MaxEingestBelastungProgrammState = 'running';
			let date = new Date();
			Programs.MaxEingestBelastungProgrammStart = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'P.03 '+t.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let scale = t.ioService.getDeviceInfo().getScale('maxHeatLoad');
			t.value = scale.getCurrentValue();
			t.unit = scale.getUnit();
			if(idx == 0){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.MaxEingestBelastungProgrammStart;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING')+"...";
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}


				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING')+"...";

				}
				Programs.MaxEingestBelastungProgrammState='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.MaxEingestBelastungProgrammStart;
				Programs.MaxEingestBelastungProgrammStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.MaxEingestBelastungProgrammState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}



	static actuatortest_07Start : number;
	static actuatortest_07Runs = 0;
	static actuatortest_07State = 'stopped';
	static actuatortest_07(t:any){
		Programs.actuatortest_07Runs++;
		console.log("Program running: "+Programs.actuatortest_07Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_07State == 'stopped'){
			Programs.actuatortest_07State = 'running';
			let date = new Date();
			Programs.actuatortest_07Start = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.07 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_MIN_MODULATION');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let scale = t.ioService.getDeviceInfo().getScale('burnerMinModulation');

			t.value = scale.getCurrentValue();
			if(!t.value){
				t.value ="0";
			}
			t.unit = scale.getUnit();


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_BURNER_ON_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_07Start;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					//return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_07State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_07Start;
				Programs.actuatortest_07Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_07State = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}

	static actuatortest_06Start : number;
	static actuatortest_06Runs = 0;
	static actuatortest_06State = 'stopped';
	static actuatortest_06(t:any){
		Programs.actuatortest_06Runs++;
		console.log("Program running: "+Programs.actuatortest_06Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_06State == 'stopped'){
			Programs.actuatortest_06State = 'running';
			let date = new Date();
			Programs.actuatortest_06Start = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.06 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';

			t.unit = "";


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_06Start;
				
				if(diff <= 1000){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_06State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_06Start;
				Programs.actuatortest_06Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_06State = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}




	static actuatortest_05Start : number;
	static actuatortest_05Runs = 0;
	static actuatortest_05State = 'stopped';
	static actuatortest_05(t:any){
		Programs.actuatortest_05Runs++;
		console.log("Program running: "+Programs.actuatortest_05Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_05State == 'stopped'){
			Programs.actuatortest_05State = 'running';
			let date = new Date();
			Programs.actuatortest_05Start = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.05 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			t.unit = "";


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_05Start;
				
				if(diff <= 1000){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_05State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_05Start;
				Programs.actuatortest_05Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_05State = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}



	static actuatortest_04Start : number;
	static actuatortest_04Runs = 0;
	static actuatortest_04State = 'stopped';
	static actuatortest_04(t:any){
		Programs.actuatortest_04Runs++;
		console.log("Program running: "+Programs.actuatortest_04Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_04State == 'stopped'){
			Programs.actuatortest_04State = 'running';
			let date = new Date();
			Programs.actuatortest_04Start = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.04 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';

			t.unit = "";


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_04Start;
				
				if(diff <= 1000){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					t.value = t.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_04State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_04Start;
				Programs.actuatortest_04Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_04State = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}



	static actuatortest_03Start : number;
	static actuatortest_03Runs = 0;
	static actuatortest_03State = 'stopped';
	static actuatortest_03(t:any){
		Programs.actuatortest_03Runs++;
		console.log("Program running: "+Programs.actuatortest_03Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		let initialValue = t.ioService.getDeviceInfo().getScale('fanSpeed').getCurrentValue();
		t.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(14);
		if(Programs.actuatortest_03State == 'stopped'){
			Programs.actuatortest_03State = 'running';
			let date = new Date();
			Programs.actuatortest_03Start = parseInt(""+date.getTime());
		}
		
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.03 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_FAN');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let scale = t.ioService.getDeviceInfo().getScale('fanSpeed');

			t.value = scale.getCurrentElement();
			if(!t.value){
				t.value ="0";
			}
			t.unit = scale.getUnit();


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_03Start;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_03State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === 'up' || evt == 'panup'){
				t.ioService.getDeviceInfo().getScale('fanSpeed').increase(true);
				return;
			}
			if(evt === 'down'|| evt == 'pandown'){
				t.ioService.getDeviceInfo().getScale('fanSpeed').decrease(true);
				return;
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_03Start;
				Programs.actuatortest_03Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_03State = 'stopped';
						eH.call(t,'back');
						t.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(initialValue);
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}

	static actuatortest_02Start : number;
	static actuatortest_02Runs = 0;
	static actuatortest_02State = 'stopped';
	static actuatortest_02(t:any){
		Programs.actuatortest_02Runs++;
		console.log("Program running: "+Programs.actuatortest_02Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_02State == 'stopped'){
			Programs.actuatortest_02State = 'running';
			let date = new Date();
			Programs.actuatortest_02Start = parseInt(""+date.getTime());
		}
		
		let initialValue = t.ioService.getDeviceInfo().getScale('threewayValveState').getCurrentValue();
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.01 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			t.value = t.ioService.getDeviceInfo().getScale('threewayValveState').toString();
			
			t.unit = "";


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_02Start;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}
				if(diff > 1000 && diff < duration ){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_02State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === 'up' || evt == 'panup'){
				t.ioService.getDeviceInfo().getScale('threewayValveState').increase(true);
				return;
			}
			if(evt === 'down'|| evt == 'pandown'){
				t.ioService.getDeviceInfo().getScale('threewayValveState').decrease(true);
				return;
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_02Start;
				Programs.actuatortest_02Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_02State = 'stopped';
						eH.call(t,'back');
						t.ioService.getDeviceInfo().getScale('threewayValveState').setCurrentValue(initialValue);
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}



	static actuatortest_01Start : number;
	static actuatortest_01Runs = 0;
	static actuatortest_01State = 'stopped';
	static actuatortest_01(t:any){
		Programs.actuatortest_01Runs++;
		console.log("Program running: "+Programs.actuatortest_01Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.actuatortest_01State == 'stopped'){
			Programs.actuatortest_01State = 'running';
			let date = new Date();
			Programs.actuatortest_01Start = parseInt(""+date.getTime());
		}
		let initialValue = t.ioService.getDeviceInfo().getScale('internalPump').getCurrentValue();
		let duration = 15*60*1000;
		t.getText = function(idx:number){
			t.title = 'T.01 '+t.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_PUMP');
			t.showIconBar = true;
			t.menuIcon = 'iconInstallerGrey';
			let scale = t.ioService.getDeviceInfo().getScale('internalPump');
			t.value = scale.getCurrentValue();
			t.unit = scale.getUnit();


			if(idx == 0){
				return t.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_PUMP_DESCRIPTION');
			}
			if(idx == 2){
				return t.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if(idx == 1){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.actuatortest_01Start;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > 1000 && diff < duration ){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_01State='stopped';
				return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			console.log("Handling event: "+evt);

			if(evt === 'up' || evt == 'panup'){
				t.ioService.getDeviceInfo().getScale('internalPump').increase(true);
				return;
			}
			if(evt === 'down'|| evt == 'pandown'){
				t.ioService.getDeviceInfo().getScale('internalPump').decrease(true);
				return;
			}
			if(evt == 'confirm'){
				return;
			}
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.actuatortest_01Start;
				Programs.actuatortest_01Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.actuatortest_01State = 'stopped';
						eH.call(t,'back');
						console.log("initialValue:"+initialValue);
						t.ioService.getDeviceInfo().getScale('internalPump').setCurrentValue(initialValue);
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}




	static hydraulicBalanceStart : number;
	static hydraulicBalanceRuns = 0;
	static hydraulicBalanceState = 'stopped';
	static hydraulicBalance(t:any){
		Programs.hydraulicBalanceRuns++;
		console.log("Program running: "+Programs.hydraulicBalanceRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.hydraulicBalanceState == 'stopped'){
			Programs.hydraulicBalanceState = 'running';
			let date = new Date();
			Programs.hydraulicBalanceStart = parseInt(""+date.getTime());
		}
		
		let duration = 6*60*1000;
		t.getText = function(idx:number){
			
			t.dashIcon = 'iconMobile';
			t.menuIcon = 'iconInstallerGrey';
			t.value = "";
			t.unit = "";


			if(idx == 2){

				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.hydraulicBalanceStart;
				
				if(diff <= 1000){
					//return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff < duration ){
					return t.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if(diff >= duration && (diff-1000) <= (duration)){
					//return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
				}
				Programs.hydraulicBalanceState='stopped';
				//return t.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+t.translator.tr('DELIGHT_TEST_MODE_STOPPED');
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt === 'question'){
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.hydraulicBalanceStart;
				Programs.hydraulicBalanceStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.hydraulicBalanceState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}









	static BBBB_Start : number;
	static BBBB_Runs = 0;
	static BBBB_State = 'stopped';
	static BBBB_(t:any){
		Programs.BBBB_Runs++;
		console.log("Program running: "+Programs.BBBB_Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.BBBB_State == 'stopped'){
			Programs.BBBB_State = 'running';
			let date = new Date();
			Programs.BBBB_Start = parseInt(""+date.getTime());
		}
		
		let duration = 5*1000;
		t.getText = function(idx:number){
			if(idx == 0){
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.BBBB_Start;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > duration){
					t.node.addButton('confirm');t.menuService
					Programs.BBBB_State='done';
					return t.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_EXPLANATION');
				}
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt == 'confirm'){
				if(Programs.BBBB_State == 'done'){
					Programs.BBBB_State = 'terminating';
					t.getText = function(idx:number){
						return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					setTimeout(
						()=>{
							Programs.BBBB_State = 'stopped';
							t.eventHandler = eH;
							t.getText = getText;
							t.node.removeButton('confirm');
							let target = t.node.getTargetNode();
							if(target){
								t.menuService.goto(target);
								return;
							}
						},3000);
					return;
				}
				if(Programs.BBBB_State == 'terminating'){
					t.getText = (idx)=>{
						return t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					return;
				}
				if(Programs.BBBB_State == 'stopped'){
					
				}
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.BBBB_Start;
				Programs.BBBB_Start -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.BBBB_State = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}


	static BasicChimneySweeepMinDHW_Start : number;
	static BasicChimneySweeepMinDHW_Runs = 0;
	static BasicChimneySweeepMinDHW_State = 'stopped';
	static BasicChimneySweeepMinDHW(t:any){
		Programs.BasicChimneySweeepMinDHW_Runs++;
		console.log("Program running: "+Programs.BasicChimneySweeepMinDHW_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');

		t.getIconBar().saveState('beforeMinDHWChimney');
		//t.getIconBar().disableAll();
		//t.getIconBar().enableIcon('burner');
		//t.getIconBar().enableIcon('operationTime');

		let value : number =5;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '25.0'
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(8,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = '';
			t.bigLetters = 'S.093'
			t._unit = undefined;
		});
		scheduler.at(19,()=>{
			t.smallLetters = '15:00';
			t.bigLetters = '25.0'

			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		for(let i=0;i<15*60;i++){
			scheduler.at(20+i,()=>{
				t.smallLetters = Helper.twoDigits( Math.floor( (15*60-i-1)/60 ) )+':'+Helper.twoDigits( (15*60-i-1)%60 );
				
				let b = parseFloat(t.bigLetters);
				if(b<80 && (i%1)==0 ){
					b+=0.5;
				}
				t.bigLetters = b.toFixed(1);
				t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
			});
		}
		scheduler.at(15*60+23,()=>{
			t.smallLetters = '--:--';
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(15*60+27,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(15*60+30,()=>{
			t.menuService.goto('chimneysweepmodemenu');
			t.getIconBar().restoreState('beforeMinDHWChimney');
			scheduler.cancel();
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 15*60+23){
				return;
			}
			if(evt=='back'){
				
				scheduler.gotoTick(15*60+30);
			}
		};
		


	}
	static BasicChimneySweeepMaxDHW_Start : number;
	static BasicChimneySweeepMaxDHW_Runs = 0;
	static BasicChimneySweeepMaxDHW_State = 'stopped';
	static BasicChimneySweeepMaxDHW(t:any){
		Programs.BasicChimneySweeepMaxDHW_Runs++;
		console.log("Program running: "+Programs.BasicChimneySweeepMaxDHW_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');

		t.getIconBar().saveState('beforeMaxDHWChimney');
		//t.getIconBar().disableAll();
		//t.getIconBar().enableIcon('burner');
		//t.getIconBar().enableIcon('operationTime');
		let value : number = 35;
		scheduler.at(3,()=>{
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '25.0'
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(8,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = '';
			t.bigLetters = 'S.093'
			t._unit = undefined;
		});
		scheduler.at(19,()=>{
			t.smallLetters = '15:00';
			t.bigLetters = '25.0'

			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});

		for(let i=0;i<15*60;i++){
			scheduler.at(20+i,()=>{
				t.smallLetters = Helper.twoDigits( Math.floor( (15*60-i-1)/60 ) )+':'+Helper.twoDigits( (15*60-i-1)%60 );
				
				let b = parseFloat(t.bigLetters);
				if(b<80 && (i%1)==0 ){
					b+=0.5;
				}
				t.bigLetters = b.toFixed(1);
				t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
			});
		}
		scheduler.at(15*60+23,()=>{
			t.smallLetters = '--:--';
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(15*60+27,()=>{
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._showScale = true;
			t._unit = '';
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(15*60+30,()=>{
			t.getIconBar().restoreState('beforeMaxDHWChimney');
			t.menuService.goto('chimneysweepmodemenu');
			scheduler.cancel();
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 15*60+23){
				return;
			}
			if(evt=='back'){
				
				scheduler.gotoTick(15*60+23);
			}
		};
		


	}




	static BasicChimneySweepDynamic_Start : number;
	static BasicChimneySweepDynamic_Runs = 0;
	static BasicChimneySweepDynamic_State = 'stopped';
	static BasicChimneySweepDynamic(t:any){
		Programs.BasicChimneySweepDynamic_Runs++;
		console.log("Program running: "+Programs.BasicChimneySweepDynamic_Runs);
		let scheduler = new Scheduler();
		t._showScale = true,
		t._scaleType = 'loadinganimation';
		t.menuService.disableButton('slider');
		t.menuService.disableButton('up');
		t.menuService.disableButton('down');
		t.menuService.disableButton('menu');

		t.getIconBar().saveState('beforeDynDHWChimney');
		t.getIconBar().disableAll();
		//t.getIconBar().enableIcon('burner');
		//t.getIconBar().enableIcon('operationTime');
		let value : number =16;
		scheduler.at(3,()=>{
			t.menuService.undisableButton('slider');
			t.menuService.undisableButton('up');
			t.menuService.undisableButton('down');
			t._showScale = false;
			t._scaleType = '';
			t.smallLetters = '--:--';
			t.bigLetters = '25.0'
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(8,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = '';
			t.bigLetters = 'S.093'
			t._unit = undefined;
		});
		scheduler.at(19,()=>{
			t.menuService.undisableButton('up');
			t.menuService.undisableButton('down');
			t.menuService.undisableButton('slider');
			t.smallLetters = '15:0';
			t.bigLetters = '25.0'

			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		for(let i=0;i<15*60;i++){
			scheduler.at(20+i,()=>{
				t.smallLetters = Helper.twoDigits( Math.floor( (15*60-i-1)/60 ) )+':'+Helper.twoDigits( (15*60-i-1)%60 );
				
				let b = parseFloat(t.bigLetters);
				if(b<80 && (i%1)==0 ){
					b+=0.5;
				}
				t.bigLetters = b.toFixed(1);
			});
		}
		scheduler.at(15*60+23,()=>{
			t.smallLetters = '--:--';
			
			t._unit = 'STD_UNIT_CELSIUS_NORMAL_LEFT';
		});
		scheduler.at(15*60+26,()=>{
			t.menuService.disableButton('slider');
			t.menuService.disableButton('up');
			t.menuService.disableButton('down');
			t.smallLetters = 'off';
			t.bigLetters = '';
			t._unit = '';
			t._showScale = true;
			t._scaleType = 'loadinganimation';
			
		});

		scheduler.at(15*60+29,()=>{
			t.menuService.goto('chimneysweepmodemenu');
			//t.getIconBar().restoreState('beforeDynDHWChimney');
			scheduler.cancel();
		});
		scheduler.run();
		t.handler = (evt)=>{
			if(!scheduler.isRunning()){
				return;
			}
			if(scheduler.currentTick() >= 15*60+23){
				return;
			}
			if(evt=='back'){
				t._useOverride = false;
				scheduler.gotoTick(15*60+23);
			}
			if(evt == 'up'|| evt == 'down'){
				let value = 16;
				if(t.value){
					value = t.value;
				}
				if(evt == 'up'){
					value++;
					if(value > 20){
						value = 5;
					}
				}
				if(evt == 'down'){
					value--;
					if(value < 5){
						value = 20;
					}
				}
				t.value = value;
				t._overrideBigLetters = t.value+"";

				t._overrideUnit = 'AICI_UNIT_KW';
				t._useOverride = true;
				if(t.undoOverride){
					clearTimeout(t.undoOverride);
					t.undoOverride = undefined;
				}
				t.undoOverride = setTimeout( ()=>{
					t._useOverride = false;
				},2000);
			}
		};
		


	}





	static WaterFillStart : number;
	static WaterFillRuns = 0;
	static WaterFillState = 'stopped';
	static WaterFill(t:any){
		Programs.WaterFillRuns++;
		console.log("Program running: "+Programs.WaterFillRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if(Programs.WaterFillState == 'stopped'){
			Programs.WaterFillState = 'running';
			let date = new Date();
			Programs.WaterFillStart = parseInt(""+date.getTime());
		}
		
		let duration = 5*1000;
		t.getText = function(idx:number){
			if(idx == 0){
				let d = new Date();
				let diff = parseInt(""+d.getTime())-Programs.WaterFillStart;
				
				if(diff <= 1000){
					return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if(diff > duration){
					t.node.addButton('confirm');
					Programs.WaterFillState='done';
					return t.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_EXPLANATION');
				}
				
			}else{
				return getText.call(t,idx);
			}
		}
		t.eventHandler = function(evt){
			if(evt == 'confirm'){
				if(Programs.WaterFillState == 'done'){
					Programs.WaterFillState = 'terminating';
					t.getText = function(idx:number){
						return t.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM')+" "+t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					setTimeout(
						()=>{
							Programs.WaterFillState = 'stopped';
							t.eventHandler = eH;
							t.getText = getText;
							t.node.removeButton('confirm');
							let target = t.node.getTargetNode();
							if(target){
								t.menuService.goto(target);
								return;
							}
						},3000);
					return;
				}
				if(Programs.WaterFillState == 'terminating'){
					t.getText = (idx)=>{
						return t.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					return;
				}
				if(Programs.WaterFillState == 'stopped'){
					
				}
				return;
			}
			if(evt === "back"){
				let d = new Date();
				let diff = d.getTime()-Programs.WaterFillStart;
				Programs.WaterFillStart -= (duration-diff);
				t.eventHandler = eH;
				setTimeout(
					()=>{
						Programs.WaterFillState = 'stopped';
						eH.call(t,'back');
					},
					2000
				);
			}else{
				eH.call(t,evt);
			}
		}
	}


}